import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import { css } from "styled-components/macro"; //eslint-disable-line
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Public Pages
import MainP from "MainP";
import LoginPage from "pages/Login.js";
import SignupPage from "pages/Signup.js";
import AboutUs from "pages/AboutUs";
import Departments from "pages/departments";
import Alumnipage from "pages/Alumnipage";
import DonationPage from "pages/DonationPage";
import MagazineLayout from "pages/MagazineLayout";
import MagazineDetail from "pages/MagazineDetail";
import SalsabeelIssues from "pages/MagazinePage";
import MagazineAccordion from "pages/MagazineAccordion";
import AdmissionFormPage from "pages/AdmissionFormPage";
import EventsPage from "pages/EventsandUpdates";
import BlogIndex from "pages/BlogIndex";
import Aboutpage from "pages/Aboutpage";
import ThankYouPage from "ThankYouPage.js";
import ComponentRenderer from "ComponentRenderer.js";
import Layout from "components/layouts/Layout";
import FacebookPage from "pages/FacebookPage";
import EventDetail from "pages/EventDetail";
import PhotoGalleryPage from "pages/PhotoGalleryPage";

// Admin Pages
import AdminLayout from "pages/admin/AdminLayout";
import Dashboard from "pages/admin/Dashboard";
import Users from "pages/admin/Users";

// React Query setup
const queryClient = new QueryClient();

export default function App() {
  return (
    <>
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <div style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
          <Router>
            <Routes>
              {/* Component Preview */}
              <Route
                path="/components/:type/:subtype/:name"
                element={<ComponentRenderer />}
              />
              <Route
                path="/components/:type/:name"
                element={<ComponentRenderer />}
              />

              {/* Public Routes */}
              <Route path="/" element={<MainP />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/alumni" element={<Alumnipage />} />
              <Route path="/donation" element={<DonationPage />} />
              <Route path="/admission" element={<AdmissionFormPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/facebook" element={<FacebookPage />} />
              <Route path="/photo-gallery" element={<PhotoGalleryPage />} />
              <Route path="/magazine" element={<SalsabeelIssues />} />
              <Route path="/magazine/:id" element={<MagazineDetail />} />
              <Route
                path="/magazine/categories"
                element={<MagazineAccordion />}
              />
              <Route
                path="/mgp"
                element={
                  <Layout>
                    <MagazineLayout />
                  </Layout>
                }
              />
              <Route path="/thank-you" element={<ThankYouPage />} />

              {/* Admin Routes */}
              <Route path="/admin/*" element={<AdminLayout />}>
                <Route index element={<Dashboard />} /> {/* /admin */}
                <Route path="dashboard" element={<Dashboard />} />{" "}
                {/* /admin/dashboard */}
                <Route path="users" element={<Users />} /> {/* /admin/users */}
              </Route>
            </Routes>
          </Router>
        </div>
      </QueryClientProvider>
    </>
  );
}
